(() => {
  if (window.Shopify?.designMode || window.dfwClarityOrdersLoaded) return;
  window.dfwClarityOrdersLoaded = true;

  const project = 'o48q5sqlyv';
  const keys = ['__dfw_clarity_recording', '__dfw_clarity_reference'];
  const root = window.Shopify?.routes?.root || '/';
  let metadata, attributes = {}, saved = '', timer, bindingTimer, running = false, queued = false;
  let bound = false, attempts = 0, failures = 0, revision = 0, deniedCleaned = false, privacyRequested = false;
  let clearing = Promise.resolve();

  function consent() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
    } catch {
      return undefined;
    }
  }

  function allowed() { return consent() === true; }

  function cartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    try {
      const url = new URL(form.action, location.href);
      return url.origin === location.origin && /\/cart\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  function attach(form) {
    if (!cartForm(form)) return;
    for (const key of keys) {
      let field = form.querySelector(`[data-dfw-clarity-field="${key}"]`);
      const value = allowed() ? attributes[key] : '';
      if (!value) {
        field?.remove();
        continue;
      }
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = `attributes[${key}]`;
        field.dataset.dfwClarityField = key;
        form.append(field);
      }
      field.value = value;
    }
  }

  function attachAll() {
    for (const form of document.forms) attach(form);
  }

  async function request(path, options = {}) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch(root + path, {
        credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal,
        headers: { Accept: 'application/json', ...options.headers }
      });
      if (!response.ok) throw new Error('Cart reference could not be saved');
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }

  function schedule(delay = 150) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay);
  }

  async function sync() {
    if (running) { queued = true; return; }
    running = true;
    const version = revision;
    try {
      if (!metadata || !allowed()) return;
      await clearing;
      if (version !== revision || !allowed()) return;
      const current = { ...metadata };
      const cart = await request('cart.js');
      if (version !== revision || !allowed()) return;
      if (!cart.item_count || typeof cart.token !== 'string') {
        attributes = {}; saved = ''; attachAll();
        return;
      }
      const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(cart.token));
      const reference = 'dfw-' + Array.from(new Uint8Array(hash)).slice(0,16).map(n => n.toString(16).padStart(2,'0')).join('');
      if (version !== revision || !allowed()) return;
      const url = `https://clarity.microsoft.com/player/${project}/${current.userId}/${current.sessionId}/`;
      attributes = { [keys[0]]: url, [keys[1]]: reference };
      attachAll();
      window.clarity('set', 'dfw_order_reference', reference);
      const signature = JSON.stringify(attributes);
      if (signature !== saved) {
        await request('cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        });
        if (version === revision && allowed()) saved = signature;
        else await clearSaved();
      }
      failures = 0;
    } catch {
      if (failures++ < 2) schedule(1500 * failures);
    } finally {
      running = false;
      if (queued) { queued = false; schedule(); }
    }
  }

  function clearSaved() {
    attributes = {}; saved = ''; attachAll();
    clearing = clearing.then(async () => {
      const cart = await request('cart.js');
      if (!cart.item_count) return;
      await request('cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [keys[0]]: '', [keys[1]]: '' } })
      });
    }).catch(() => {});
    return clearing;
  }

  function receive(data, playback) {
    if (!allowed() || !playback || data?.projectId !== project) return;
    if (![data.userId, data.sessionId].every(value => typeof value === 'string' && /^[a-z0-9]+$/i.test(value))) return;
    if (metadata?.userId !== data.userId || metadata?.sessionId !== data.sessionId) revision++;
    metadata = { userId: data.userId, sessionId: data.sessionId };
    schedule();
  }

  function bind() {
    clearTimeout(bindingTimer);
    if (!window.Shopify?.customerPrivacy && !privacyRequested && typeof window.Shopify?.loadFeatures === 'function') {
      privacyRequested = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (!error) { attempts = 0; bind(); }
        });
      } catch {}
    }
    if (!deniedCleaned && consent() === false) {
      deniedCleaned = true;
      void clearSaved();
    }
    if (!allowed() || typeof window.clarity !== 'function') {
      if (attempts++ < 60) bindingTimer = setTimeout(bind, 500);
      return;
    }
    deniedCleaned = false;
    if (!bound) {
      try {
        window.clarity('metadata', receive, true, true);
        bound = true;
      } catch {}
    }
  }

  for (const name of ['shopify:cart:lines-update', 'cart:update', 'cart-section:restored']) {
    document.addEventListener(name, async event => {
      try { await event.promise; } catch {}
      failures = 0; schedule();
    });
  }
  document.addEventListener('submit', event => { attach(event.target); }, true);
  document.addEventListener('visitorConsentCollected', () => {
    revision++;
    if (!allowed()) {
      deniedCleaned = true;
      metadata = undefined; clearTimeout(timer); clearTimeout(bindingTimer);
      void clearSaved();
    } else {
      bound = false; attempts = 0; bind();
    }
  });
  window.addEventListener('pageshow', () => { attempts = 0; bind(); schedule(); });
  window.addEventListener('focus', () => { attempts = 0; bind(); schedule(); });
  bind();
})();
